import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import SideDrawer from 'app/components/CommonStyled/SideDrawer';
import FeedbackDrawer from 'app/components/ContactDrawers/FeedbackDrawer';
import { ResourceSubmissionModalContext } from 'app/components/ResourceSubmissionModal/ResourceSubmissionModalContext';
import {
  KyuLaurelBadgeIcon,
  ResetIcon,
  ResourceIcon,
  RichResourceIcon,
} from 'app/components/shared/icons';
import { setShowResourceSubmissionModal } from 'store/reducers/resource-submission/resource-submission-reducer';

import { ResourceSubmissionContext } from '../ResourceSubmissionContext';
import {
  ResourceSubmissionFailureButtonsContainer,
  ResourceSubmissionFailureContactTeam,
  ResourceSubmissionFailureContainer,
  ResourceSubmissionFailureDescription,
  ResourceSubmissionFailureIconContainer,
  ResourceSubmissionFailureShareButton,
  ResourceSubmissionFailureShareButtonText,
  ResourceSubmissionFailureStatus,
  ResourceSubmissionFailureTitle,
  ResourceSubmissionFailureWrapper,
} from './styled';

interface ResourceSubmissionFailureProps {
  status: number;
}

export default function ResourceSubmissionFailure({ status }: ResourceSubmissionFailureProps) {
  const dispatch = useDispatch();
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const { setPreventClose } = useContext(ResourceSubmissionModalContext);
  const { setIsError } = useContext(ResourceSubmissionContext);

  useEffect(() => {
    setPreventClose(true);

    return () => {
      setPreventClose(false);
    };
  }, []);

  const handleTryAgainClick = () => {
    setIsError(false);
  };

  const handleContactTeamClick = () => {
    setShowDrawer(true);
  };

  const handleBackToMainPageClick = () => {
    dispatch(setShowResourceSubmissionModal(false));
  };

  return (
    <ResourceSubmissionFailureWrapper>
      <ResourceSubmissionFailureContainer>
        <ResourceSubmissionFailureIconContainer>
          <RichResourceIcon width={40} height={40} />
        </ResourceSubmissionFailureIconContainer>
        <ResourceSubmissionFailureTitle>
          Oh no - something went wrong.
        </ResourceSubmissionFailureTitle>
        <ResourceSubmissionFailureDescription>
          What an anti-climax.
          <br />
          <br />
          Something unexpected happened and your submission hasn’t been created.
          <br />
          <br />
          Click Try Again to go back and resubmit. All the information you shared will still be
          present.
        </ResourceSubmissionFailureDescription>
        <ResourceSubmissionFailureStatus>STATUS: {status}</ResourceSubmissionFailureStatus>
        <ResourceSubmissionFailureButtonsContainer>
          <ResourceSubmissionFailureShareButton onClick={handleTryAgainClick}>
            <ResourceSubmissionFailureShareButtonText>
              TRY AGAIN
            </ResourceSubmissionFailureShareButtonText>
            <ResetIcon width={24} height={24} fill="var(--color-primary)" fillOpacity="1" />
          </ResourceSubmissionFailureShareButton>
          <ResourceSubmissionFailureShareButton onClick={handleBackToMainPageClick}>
            <ResourceSubmissionFailureShareButtonText>
              BACK TO THE RESOURCE LIBRARY
            </ResourceSubmissionFailureShareButtonText>
          </ResourceSubmissionFailureShareButton>
        </ResourceSubmissionFailureButtonsContainer>
        <ResourceSubmissionFailureContactTeam onClick={handleContactTeamClick}>
          OR MESSAGE THE CREATIVE INTELLIGENCE TEAM
        </ResourceSubmissionFailureContactTeam>
      </ResourceSubmissionFailureContainer>
      {showDrawer && (
        <SideDrawer closeDrawer={() => setShowDrawer(false)} withClose>
          <FeedbackDrawer />
        </SideDrawer>
      )}
    </ResourceSubmissionFailureWrapper>
  );
}
